'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOneYrAnnualized = exports.getAriaSort = exports.getHypoChartProps = exports.getEsgApproachInfo = exports.getDocumentsFromContentByDocType = exports.getFxColIndexForRowHeight = exports.getFavoriteFunds = exports.isFavoriteFund = exports.getFactSheetUrl = exports.isUKOeicsOrInvTrust = exports.isFundTypeFilterETF = exports.isJPETF = exports.isJPNonLiq = exports.isSGNonLiq = exports.isHKNonLiqMobile = exports.isAPACNonLiqMobile = exports.isAPACNonLiq = exports.getFormattedNavDateAndValueForNonIntraDayNav = exports.getLanguageSpecificFactSheetUrlFromContentConfig = exports.getDocUrlFromContentConfig = exports.mergeFundManagersContentData = exports.getFormattedNavDateAndValueForIntraDayNav = exports.getFormattedNavDateAndValue = exports.isUSSMAFund = exports.isCAEtfFund = exports.isAUEtfFund = exports.isUSEtfFund = exports.getSearchPlaceholderStyle = exports.getSearchPlaceholderTextId = exports.getNAVValue = undefined;

var _number_utility = require('./number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _functional_utility = require('./functional_utility');

var _ramda = require('ramda');

var _date_formatter = require('./date_formatter');

var _currency_utility = require('./currency_utility');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _collection_utility = require('./collection_utility');

var _cms_utility = require('./cms_utility');

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _withSortableRows = require('../../responsive-table/src/ResponsiveTable/hoc/withSortableRows');

var _string_utility = require('./string_utility');

var _string_utility2 = _interopRequireDefault(_string_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getNAVValue = function getNAVValue(fundTypeOrLegalStructure, value, country, decimalPlaces) {
  var visibleData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var formattedValue = void 0;

  if ((0, _ramda.isNil)(value) || value === "-" || value === "NaN") {
    return '-';
  }

  if (country === "tw") {
    formattedValue = _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(value, decimalPlaces));
  } else if ((0, _ramda.and)(fundTypeOrLegalStructure === 'N_ETF', country !== "us")) {
    formattedValue = _number_utility2.default.convertToAmount(value, decimalPlaces >= 0 ? decimalPlaces : 3);
  } else if (country === "hk" || country === "au" && fundTypeOrLegalStructure === "AUSTRALIA_UNIT_TRUST" || country === "jp") {
    if (fundTypeOrLegalStructure === "Mainland_HK_MRF_FUNDS") {
      formattedValue = value;
    } else if (fundTypeOrLegalStructure === "JAPAN_INVESTMENT_TRUST") {
      formattedValue = _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(value, decimalPlaces));
    } else {
      var dp = decimalPlaces >= 0 ? decimalPlaces : 2;

      // TODO: see if this rule can be removed and use the dp from backend directly in the future.
      // Note that even in retail-fund there might be different dp for each ISIN
      var unlimitedDp = (0, _ramda.includes)('NAV_DECIMAL_PLACES_UNLIMITED', visibleData.formattingRules || []);
      if (unlimitedDp) {
        dp = value === 0 ? 2 : decimalPlaces;
      }

      formattedValue = _number_utility2.default.convertToAmountWithPreciseRounding(value, dp, '—', false, true);
    }
  } else if (fundTypeOrLegalStructure === "FT_LUX_FUND" && (0, _functional_utility.isEmeaRegion)(country)) {
    decimalPlaces = value === 0 ? 2 : decimalPlaces;
    formattedValue = _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(value, decimalPlaces));
  } else {
    formattedValue = _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(value, decimalPlaces >= 0 ? decimalPlaces : 2));
  }

  return formattedValue;
};

var getSearchPlaceholderIdForUS = function getSearchPlaceholderIdForUS(country, role, fundType) {
  var id = 'placeholder-text-name-ticker-cusip';
  if (role === 'liq' && (fundType === 'liquidity' || fundType === 'bond')) {
    id = 'placeholder-text-name-isin';
  }
  if (role === 'ny529') {
    id = 'placeholder-text-name-cusip';
  }
  if (fundType === 'sma') {
    id = 'placeholder-text-name-strategy';
  }
  return id;
};

var getSearchPlaceholderIdForGB = function getSearchPlaceholderIdForGB(country, role, fundType) {
  var id = 'placeholder-text-name-ticker-isin';

  if (fundType === 'investment_trusts') {
    id = 'placeholder-text-product-name-ticker-isin';
  } else if (fundType === 'sicavs' || fundType === 'oeics') {
    id = 'placeholder-text-name-isin-sedol';
  }

  return id;
};

var getSearchPlaceholderTextId = function getSearchPlaceholderTextId(country, role, fundType) {
  var isJTF = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var placeholderTextId = 'placeholder-text-name-ticker-isin';

  if (country === 'us' || fundType === 'etf-us') {
    placeholderTextId = getSearchPlaceholderIdForUS(country, role, fundType);
  } else if (role === "liq") {
    placeholderTextId = 'placeholder-text-name-ticker-isin';
  } else if (country === 'hk' || country === 'sg' || country === 'cn' || country === 'jp') {
    placeholderTextId = 'placeholder-text-name-isin-bloomberg';
  } else if (country === 'gb') {
    placeholderTextId = getSearchPlaceholderIdForGB(country, role, fundType);
  } else if (country === 'de') {
    placeholderTextId = 'placeholder-text-isin-ticker-wkn';
  } else if (fundType === 'sicavs' || fundType === 'eltifs' || fundType === 'liquidity-fund') {
    if (country === 'ch') {
      placeholderTextId = 'placeholder-text-name-isin-valor';
    } else if ((0, _functional_utility.isEmeaRegion)(country)) {
      placeholderTextId = 'placeholder-text-name-isin';
    }
  } else if (country === 'au') {
    if (fundType === 'auut') {
      placeholderTextId = isJTF ? 'placeholder-jtf-text-name-ticker-apir' : 'placeholder-text-name-isin-apir';
    } else {
      placeholderTextId = isJTF ? 'placeholder-jtf-text-name-ticker-apir' : 'placeholder-text-name-ticker-isin';
    }
  }

  return placeholderTextId;
};

var getSearchPlaceholderStyle = function getSearchPlaceholderStyle(country, breakpoint, isFocused) {

  var placholderStyle = 'jump-to-fund-placehoder category';
  if (country === 'hk') {
    placholderStyle = 'jump-to-fund-placehoder jump-to-fund-placehoder-apac';
    if (breakpoint < 2) {
      placholderStyle = "jump-to-fund-placehoder jump-to-fund-placehoder-apac-mobile width-percent-90";
    }
  }

  placholderStyle = isFocused ? placholderStyle + ' jump-to-fund-placehoder-focus' : placholderStyle;

  return placholderStyle;
};
var isUSEtfFund = function isUSEtfFund(country, fundType) {
  return country === 'us' && fundType === 'N_ETF';
};

var isAUEtfFund = function isAUEtfFund(country, fundType) {
  return country === 'au' && fundType === 'N_ETF';
};

var isCAEtfFund = function isCAEtfFund(country, fundType) {
  return country === 'ca' && fundType === 'N_ETF';
};

var isUSSMAFund = function isUSSMAFund(country, fundType) {
  return country === 'us' && fundType === 'SMA';
};

var isFundTypeFilterETF = function isFundTypeFilterETF(filterFundType) {
  return filterFundType === 'etf';
};

var isUKOeicsOrInvTrust = function isUKOeicsOrInvTrust(country, filterFundType) {
  return country === 'gb' && (filterFundType === 'investment_trusts' || filterFundType === 'oeics');
};

var getFormattedNavDateAndValue = function getFormattedNavDateAndValue(navConfig, fundData, country) {
  if (!(0, _ramda.isNil)(fundData.intraDayNav)) {
    return getFormattedNavDateAndValueForIntraDayNav(navConfig, fundData);
  } else {
    return getFormattedNavDateAndValueForNonIntraDayNav(navConfig, fundData, country);
  }
};

var getFormattedNavDateAndValueForIntraDayNav = function getFormattedNavDateAndValueForIntraDayNav(navConfig, fundData) {
  var intraDayDecimalRounding = fundData.intraDayDecimalRounding || 4;
  var formattedNav = {},
      intraDayNavMarkup = [];
  formattedNav.intraDayNav = fundData.intraDayNav;
  (0, _ramda.map)(function (data) {
    var navValue = _currency_utility2.default.convertToCurrencyWithoutDecimals(parseFloat(data.price).toFixed(intraDayDecimalRounding), fundData.currencyCode);
    navValue = _currency_utility2.default.getFormattedNavValue(navConfig.currencyCodeMode, fundData, intraDayDecimalRounding, data.price, navValue);
    intraDayNavMarkup.push({
      time: (0, _date_formatter.getTimeInHoursAndMinutesInTimeZoneFormat)(data.intraDayDateTime, navConfig.timeZone, navConfig.is24HrFormat),
      navValue: navValue
    });
  }, fundData.intraDayNav);
  formattedNav.intraDayNavMarkup = intraDayNavMarkup;
  return formattedNav;
};

var mergeFundManagersContentData = function mergeFundManagersContentData(edpiDataFundManagers, contentFundManagers) {
  _collection_utility.CollectionUtility.map(edpiDataFundManagers, function (fundManager) {
    if (!(0, _ramda.isNil)(contentFundManagers[fundManager.identifier])) {
      var aemFundManager = contentFundManagers[fundManager.identifier];
      fundManager.profileURL = aemFundManager.profileURL;
      fundManager.managerDisclosure = aemFundManager.managerDisclosure;
      fundManager.managerDisclosureSymbol = aemFundManager.managerDisclosureSymbol;
    }
  });
  return edpiDataFundManagers;
};

var getDocUrlFromContentConfig = function getDocUrlFromContentConfig(documents, pdpLink) {
  var documentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Fact Sheet (US EMEA)";
  var kidDocUrlPreferred = arguments[3];

  var docURL = void 0;

  if (!(0, _functional_utility.isNilOrEmpty)(documents)) {
    var node = documents[pdpLink.identifier];
    if (!(0, _functional_utility.isNilOrEmpty)(node)) {
      var subNodes = node.filter(function (item) {
        return (0, _ramda.propEq)("documentType", documentType, item);
      });
      if (subNodes.length > 1 && !(0, _ramda.isNil)(kidDocUrlPreferred)) {
        subNodes = subNodes.filter(function (item) {
          return item.docURL.indexOf(kidDocUrlPreferred) > -1;
        });
      }
      docURL = !(0, _functional_utility.isNilOrEmpty)(subNodes) && !(0, _functional_utility.isNilOrEmpty)(subNodes[0].docURL) ? subNodes[0].docURL : null;
    } else {
      docURL = null;
    }
  }
  return docURL;
};

var isFavoriteFund = function isFavoriteFund(favFundData, identifier) {
  var fundFavorites = (0, _functional_utility.isNilOrEmpty)(favFundData) ? [] : favFundData;
  return fundFavorites.filter(function (id) {
    return id.toUpperCase() === identifier.toUpperCase();
  }).length > 0;
};

var getFavoriteFunds = function getFavoriteFunds(favFundsData) {
  if (!((0, _ramda.isNil)(favFundsData) || (0, _functional_utility.isNilOrEmpty)(favFundsData.folders))) {
    return favFundsData.folders[0].assets.filter(function (p) {
      return p.type === "Product";
    }).map(function (p) {
      return p.id;
    });
  }
  return [];
};

var getFxColIndexForRowHeight = function getFxColIndexForRowHeight(columnIndex, dataKey, withIntraDayNAV) {
  if (withIntraDayNAV && dataKey === _constants.FX_FUND_NAV_COL_DATAKEY) {
    return columnIndex;
  } else if (dataKey === _constants.FX_FUND_NAV_DISPLAY_NAME_DATAKEY) {
    return columnIndex;
  } else {
    return 0;
  }
};

var getFactSheetUrl = function getFactSheetUrl(urlConfig, fundPDPLink) {
  var documentTag = _constants2.default.getFdTagConstants();
  if ((0, _cms_utility.isAEM)(urlConfig) && ((0, _ramda.isNil)(fundPDPLink.factsheetUrl) || urlConfig.country === "us")) {
    return getDocUrlFromContentConfig((0, _ramda.pathOr)(null, ["content", "documents"], urlConfig), fundPDPLink);
  } else {
    if (urlConfig.country === "gb" && fundPDPLink.responseFundType === "INVESTMENT_TRUST" && !(0, _ramda.isNil)(urlConfig.content) && !(0, _functional_utility.isNilOrEmpty)(urlConfig.content.documents[fundPDPLink.identifier.toUpperCase()]) && !(0, _functional_utility.isNilOrEmpty)((0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
      return x === documentTag.FUND_STORY;
    }, 'documentType'), urlConfig.content.documents[fundPDPLink.identifier.toUpperCase()]))) {
      return null;
    }
    return (0, _ramda.replace)("{gaiaRedirectUrl}", urlConfig.gaiaRedirectUrl, (0, _ramda.isNil)(fundPDPLink.factsheetUrl) ? "" : fundPDPLink.factsheetUrl);
  }
};

var getLanguageSpecificFactSheetUrlFromContentConfig = function getLanguageSpecificFactSheetUrlFromContentConfig(documents, pdpLink, language) {
  var factsheetUrl = pdpLink.factsheetUrl;
  if (!(0, _functional_utility.isNilOrEmpty)(documents)) {
    var node = documents[pdpLink.identifier];
    if (!(0, _functional_utility.isNilOrEmpty)(node)) {
      var subNodes = node.filter(function (item) {
        return (0, _ramda.propEq)("documentType", "Fact Sheet (US EMEA)", item) && (0, _ramda.propEq)("language", language, item);
      });
      factsheetUrl = !(0, _functional_utility.isNilOrEmpty)(subNodes) && !(0, _functional_utility.isNilOrEmpty)(subNodes[0].docURL) ? subNodes[0].docURL : null;
    } else {
      factsheetUrl = null;
    }
  }
  return factsheetUrl;
};

var isAPACNonLiq = function isAPACNonLiq(country, role) {
  return role !== 'liq' && (country === 'hk' || country === 'au' || country === 'sg' || country === 'jp' || country === 'cn' || country === 'tw');
};

var isJPNonLiq = function isJPNonLiq(country, role) {
  return country == 'jp' && role != 'liq';
};

var isJPETF = function isJPETF(country, fundType) {
  return country === 'jp' && fundType === 'N_ETF';
};

var isHKNonLiqMobile = function isHKNonLiqMobile(country, role, breakpoint) {
  return (0, _ramda.and)(country === 'hk' && role !== 'liq', (0, _functional_utility.isMobileBreakpoint)(breakpoint));
};

var isAPACNonLiqMobile = function isAPACNonLiqMobile(country, role, breakpoint) {
  return (0, _ramda.and)(isAPACNonLiq(country, role), (0, _functional_utility.isMobileBreakpoint)(breakpoint));
};

var isSGNonLiq = function isSGNonLiq(country, role) {
  return country === 'sg' && role !== 'liq';
};

var getFormattedNavDateAndValueForNonIntraDayNav = function getFormattedNavDateAndValueForNonIntraDayNav(navConfig, fundData, country) {

  var formattedNav = {};
  formattedNav.navDate = fundData.navDate;

  var navDecimalPoints = fundData.navDecimalPoints;
  var navValue = null;
  var fallbackValue = country === 'tw' ? '-' : '—';

  if (country === 'hk') {
    navValue = fundData.responseFundType === 'Mainland_HK_MRF_FUNDS' ? fundData.nav : _number_utility2.default.convertToAmountWithPreciseRounding(fundData.nav, navDecimalPoints, fallbackValue, false, true);
  } else {
    navValue = _currency_utility2.default.convertToCurrency(fundData.nav, fundData.shareclassCurrencyCode, fallbackValue, country);
    navValue = _currency_utility2.default.getFormattedNavValue(navConfig.currencyCodeMode, fundData, navDecimalPoints, fundData.nav, navValue, fallbackValue);
  }

  formattedNav.navValue = navValue;

  return formattedNav;
};

var getDocumentsFromContentByDocType = function getDocumentsFromContentByDocType(content, cusip, isAEM, documentType) {
  var dataArr = !(0, _functional_utility.isNilOrEmpty)(content) && (0, _functional_utility.isObjectAndHasProp)(content.documents, cusip) ? content.documents[cusip] : null;
  var filteredDocs = [];
  if (isAEM && !(0, _functional_utility.isNilOrEmpty)(dataArr)) {
    filteredDocs = (0, _ramda.filter)((0, _ramda.propSatisfies)(function (x) {
      return x === documentType;
    }, 'documentType'), dataArr);
  }
  return filteredDocs;
};

var getAriaSort = function getAriaSort(active, direction) {
  var ariaSort = "none";
  if (active) {
    if (direction === _withSortableRows.ASCENDING) {
      ariaSort = _withSortableRows.ASCENDING;
    } else {
      ariaSort = _withSortableRows.DESCENDING;
    }
  }
  return ariaSort;
};

var getHypoChartProps = function getHypoChartProps(props) {
  return {
    gaiaRedirectUrl: props.gaiaRedirectUrl,
    active: props.active,
    performanceDataForChart: props.historicalData.performanceDataForChart,
    minStartDate: props.fund.minStartDate,
    cusip: props.cusip,
    country: props.country,
    role: props.role,
    content: props.content,
    fundInceptionDate: props.fund.fundInceptionDate,
    shareClassInceptionDate: props.fund.shareClass.shareClassInceptionDate,
    fundTypeCode: props.fund.fundTypeCode,
    categoryCode: props.fund.shareClass.categoryCode,
    currencyCode: _currency_utility2.default.getCurrencyMapping(props.fund.shareClass.currencyCode, props.country),
    fundCurrencyCode: _currency_utility2.default.getCurrencyMapping(props.fund.currencyCode, props.country),
    breakpoint: props.breakpoint,
    disclosure: !(0, _ramda.isNil)(props.fund.disclosures.pdpCardGrowthChart) ? props.fund.disclosures.pdpCardGrowthChart : props.fund.disclosures.pdpCardPerformanceChart,
    tooltip: props.tooltip,
    minimumInvestments: props.fund.shareClass.minimumInvestments,
    visibleData: props.fund.visibleData,
    numberFormat: props.fund.numberFormat,
    benchmarkLongName: props.fund.benchmarkLongName,
    shareclassName: props.fund.shareClass.name,
    reBenchmarkDate: props.fund.reBenchmarkDate,
    benchmarkDate: props.fund.benchmarkDate,
    benchmarkRestructuringDate: props.fund.benchmarkRestructuringDate,
    performanceChartHeaderDisclosure: props.fund.performanceChartHeaderDisclosure,
    intl: props.intl
  };
};

var getEsgApproachInfo = function getEsgApproachInfo() {
  var fund = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if ((0, _functional_utility.isNilOrEmpty)(fund.esgData) || !fund.esgData.esgIntegrationFlag) {
    return {};
  }
  var isEmeaOrApac = (0, _functional_utility.isEmeaRegion)(country) || (0, _functional_utility.isApacRegion)(country);
  if (fund.esgData.esgBestInClassFlag) {
    return {
      wording: _string_utility2.default.renderFormattedLabel("Best In Class", "pdp-overview-esg-integrated-card-esgBestInClassFlag"),
      disclosureId: 'pdpDataPointBestInClass'
    };
  }
  if (fund.esgData.esgPositiveTiltFlag && isEmeaOrApac) {
    return {
      wording: _string_utility2.default.renderFormattedLabel("Positive Tilt", "pdp-overview-esg-integrated-card-esgPositiveTiltFlag"),
      disclosureId: 'pdpDataPointPositiveTilt'
    };
  }
  if (fund.esgData.esgThemeBasedFlag) {
    return {
      wording: _string_utility2.default.renderFormattedLabel("Thematic", "pdp-overview-esg-integrated-card-esgThemeBasedFlag"),
      disclosureId: 'pdpDataPointThematic'
    };
  }
  if (fund.esgData.esgPromoteFlag && isEmeaOrApac) {
    return {
      wording: _string_utility2.default.renderFormattedLabel("ESG Promote", "pdp-overview-esg-integrated-card-esgPromoteFlag"),
      disclosureId: 'pdpDataPointESGPromote'
    };
  }
  if (fund.esgData.esgExlusionsFlag && isEmeaOrApac) {
    return {
      wording: _string_utility2.default.renderFormattedLabel("Exclusions", "pdp-overview-esg-integrated-card-esgExlusionsFlag"),
      disclosureId: 'pdpDataPointExclusions'
    };
  }
  return {
    wording: _string_utility2.default.renderFormattedLabel("Integrated", "pdp-overview-esg-integrated-card-title"),
    disclosureId: 'pdpDataPointESGIntegrated'
  };
};

var getOneYrAnnualized = function getOneYrAnnualized(fundShareclassPerformanceReturnMonthEnd) {
  return !(0, _functional_utility.isNilOrEmpty)(fundShareclassPerformanceReturnMonthEnd) ? fundShareclassPerformanceReturnMonthEnd.filter(function (item) {
    return item.returnPeriodIndicator === "1YR";
  })[0] : null;
};

exports.getNAVValue = getNAVValue;
exports.getSearchPlaceholderTextId = getSearchPlaceholderTextId;
exports.getSearchPlaceholderStyle = getSearchPlaceholderStyle;
exports.isUSEtfFund = isUSEtfFund;
exports.isAUEtfFund = isAUEtfFund;
exports.isCAEtfFund = isCAEtfFund;
exports.isUSSMAFund = isUSSMAFund;
exports.getFormattedNavDateAndValue = getFormattedNavDateAndValue;
exports.getFormattedNavDateAndValueForIntraDayNav = getFormattedNavDateAndValueForIntraDayNav;
exports.mergeFundManagersContentData = mergeFundManagersContentData;
exports.getDocUrlFromContentConfig = getDocUrlFromContentConfig;
exports.getLanguageSpecificFactSheetUrlFromContentConfig = getLanguageSpecificFactSheetUrlFromContentConfig;
exports.getFormattedNavDateAndValueForNonIntraDayNav = getFormattedNavDateAndValueForNonIntraDayNav;
exports.isAPACNonLiq = isAPACNonLiq;
exports.isAPACNonLiqMobile = isAPACNonLiqMobile;
exports.isHKNonLiqMobile = isHKNonLiqMobile;
exports.isSGNonLiq = isSGNonLiq;
exports.isJPNonLiq = isJPNonLiq;
exports.isJPETF = isJPETF;
exports.isFundTypeFilterETF = isFundTypeFilterETF;
exports.isUKOeicsOrInvTrust = isUKOeicsOrInvTrust;
exports.getFactSheetUrl = getFactSheetUrl;
exports.isFavoriteFund = isFavoriteFund;
exports.getFavoriteFunds = getFavoriteFunds;
exports.getFxColIndexForRowHeight = getFxColIndexForRowHeight;
exports.getDocumentsFromContentByDocType = getDocumentsFromContentByDocType;
exports.getEsgApproachInfo = getEsgApproachInfo;
exports.getHypoChartProps = getHypoChartProps;
exports.getAriaSort = getAriaSort;
exports.getOneYrAnnualized = getOneYrAnnualized;